import React, {useState, useEffect} from "react"
import OrderForm from "./OrderForm"
import {ajaxUrl} from "../main";

const App = () => {
    const [display, setDisplay] = useState("form")
    const [opt, setOpt] = useState({
        str: {
            redirectingToPayment: "Redirecting to payment",
            sentPriceQuery: "Sent price query",
        }
    })

    useEffect(() => {
        fetch(ajaxUrl + '/order_form_base_options')
            .then(response => response.json())
            .then(response => response.data)
            .then(setOpt)
    }, [])

    switch (display) {
        case "redirectingPayment":
            return <div className="alert alert-info" dangerouslySetInnerHTML={{__html: opt.str.redirectingToPayment}} />
        case "sentPriceQuery":
            return <div className="alert alert-info" dangerouslySetInnerHTML={{__html: opt.str.sentPriceQuery}} />
        case "form":
            return <OrderForm
                onNeedsPayment={(orderId) => {
                    setDisplay("redirectingPayment")
                }}
                onSentPriceQuery={() => {
                    setDisplay("sentPriceQuery")
                }}
            />
        default:
            return <></>
    }
};

export default App;
